export interface MatchIncidents {
  Id: string;
  TsExternalId: string;
  FirstHalfIncidents: MatchIncident[];
  SecondHalfIncidents: MatchIncident[];
  OvertimeIncidents: MatchIncident[];
  PenaltyShootOutIncidents: MatchIncident[];
}

export interface MatchIncident {
  AssistPlayer?: MatchIncidentPlayer;
  AwayScore: number;
  GameTime: number;
  HomeScore: number;
  Kind: EIncidentKind;
  Player?: MatchIncidentPlayer;
  ReasonType?: string;
  SubstitutePlayer?: MatchIncidentPlayer;
  TeamGround: ETeamGround;
  VarResult: EIncidentVarResult | null;
  VarReason: EIncidentVarReason | null;
}

export interface MatchIncidentPlayer {
  Id: string;
  Name: string;
  NameTranslation: Record<string, string> | null;
  ShortName?: string;
  ShortNameTranslation: Record<string, string> | null;
  TsExternalId: string;
}

export enum EIncidentKind {
  GOAL = 'GOAL',
  CORNER = 'CORNER',
  OWN_GOAL = 'OWN_GOAL',
  YELLOW_CARD = 'YELLOW_CARD',
  RED_CARD = 'RED_CARD',
  CARD_UPGRADE = 'CARD_UPGRADE',
  SUBSTITUTION = 'SUBSTITUTION',
  PENALTY = 'PENALTY',
  VAR = 'VAR',
  START = 'START',
  MIDFIELD = 'MIDFIELD',
  END = 'END',
  PENALTY_MISSED = 'PENALTY_MISSED',
  OVERTIME_IS_OVER = 'OVERTIME_IS_OVER',
  PENALTY_KICK_ENDED = 'PENALTY_KICK_ENDED',
  EXTRA_TIME = 'EXTRA_TIME',
}

export enum EIncidentVarReason {
  GOAL_AWARDED = 'GOAL_AWARDED',
  GOAL_NOT_AWARDED = 'GOAL_NOT_AWARDED',
  PENALTY_AWARDED = 'PENALTY_AWARDED',
  PENALTY_NOT_AWARDED = 'PENALTY_NOT_AWARDED',
  RED_CARD_GIVEN = 'RED_CARD_GIVEN',
  CARD_UPGRADE = 'CARD_UPGRADE',
  MISTAKEN_IDENTITY = 'MISTAKEN_IDENTITY',
  OTHER = 'OTHER',
}

export enum EIncidentVarResult {
  GOAL_CONFIRMED = 'GOAL_CONFIRMED',
  GOAL_CANCELED = 'GOAL_CANCELED',
  PENALTY_CONFIRMED = 'PENALTY_CONFIRMED',
  PENALTY_CANCELED = 'PENALTY_CANCELED',
  RED_CARD_CONFIRMED = 'RED_CARD_CONFIRMED',
  RED_CARD_CANCELED = 'RED_CARD_CANCELED',
  CARD_UPGRADE_CONFIRMED = 'CARD_UPGRADE_CONFIRMED',
  CARD_UPGRADE_CANCELED = 'CARD_UPGRADE_CANCELED',
  ORIGINAL_DECISION = 'ORIGINAL_DECISION',
  ORIGINAL_DECISION_CHANGED = 'ORIGINAL_DECISION_CHANGED',
  OTHER = 'OTHER',
}

export enum ETeamGround {
  HOME = 'HOME',
  AWAY = 'AWAY',
  NEUTRAL = 'NEUTRAL',
}

export const emptyMatchIncidents: MatchIncidents = {
  Id: '',
  TsExternalId: '',
  FirstHalfIncidents: [],
  SecondHalfIncidents: [],
  OvertimeIncidents: [],
  PenaltyShootOutIncidents: [],
};
